import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const TYPE_MAP = {
  info,
  success,
  message,
  attention: important,
  warning: important,
};

export default React.memo(StatusIcon);

StatusIcon.propTypes = {
  small: PropTypes.bool,
  type: PropTypes.oneOf(['info', 'attention', 'warning', 'success', 'message']),
};

/** @private */
function StatusIcon({ type, ...props }) {
  const Icon = TYPE_MAP[type];

  return !Icon ? null : <Icon {...props} />;
}

function success({ className, small, ...props }) {
  return <i className={cx('icon-check', className)} {...props} style={{ fontSize: small ? 20 : 25 }} />;
}

function info({ className, small, ...props }) {
  return <i className={cx('icon-info-b', className)} {...props} style={{ fontSize: small ? 22 : 29 }} />;
}

function important({ className, small, ...props }) {
  return <i className={cx('icon-alert-c', className)} {...props} style={{ fontSize: small ? 22 : 29 }} />;
}

function message({ className, small, ...props }) {
  return <i className={cx('icon-chat', className)} {...props} style={{ fontSize: 22 }} />;
}
